import React, {useState, useEffect, useRef} from 'react';
import axios from 'axios';
import '../config.js';

import { theme, createFormData } from '../services/helper.js';
import { alertService } from '../services/alert.service.js';
import Progress from '../components/progress.js';

function UserProfile(props) {
  const [loading, setLoading] = useState(false);
  const [address, setAddress] = useState(props.user.address);
  const [gender, setGender] = useState(props.user.gender);
  const [pan, setPan] = useState(props.user.pan);
  const [bank, setBank] = useState(props.user.bank);
  const [bankBranch, setBankBranch] = useState(props.user.bank_branch);
  const [bankAccount, setBankAccount] = useState(props.user.bank_account);
  const [accountHolderName, setAccountHolderName] = useState(props.user.account_holder_name);
  const [dob, setDob] = useState(props.user.dob);
  const [anniversary, setAnniversary] = useState(props.user.anniversary);
  const [ifscCode, setIfscCode] = useState(props.user.ifsc_code);
  const [identity, setIdentity] = useState(props.user.identity);
  
  const handleSubmit = (event) => {
    event.preventDefault();
    if(gender && dob){
      setLoading(true);
      axios.post(global.config.api_server+'user',createFormData({
        gender: gender,
        pan: pan,
        bank: bank,
        bank_branch: bankBranch,
        bank_account: bankAccount,
        account_holder_name: accountHolderName,
        dob: dob,
        anniversary: anniversary,
        ifsc_code: ifscCode,
        identity: identity,
        address: address,
        task: 'basic_profile',
        token: localStorage.getItem("token")
      })).then(res => {
        setLoading(false);
        if(res.status === 200 && res.data.status === "success"){
          alertService.success('Profile updated');
        }else{
          alertService.error(res.data.error);
        }
      }).catch(err => {
        alertService.error(err);
        setLoading(false);
      });
    }else{
      alertService.error('Some fields are required');
    }
  }
  
  const date = new Date(dob);
  let birth_date = undefined;
  if(date.getFullYear() > 1900){
    birth_date = date.getFullYear() + "-";
    if((date.getMonth() + 1) < 10){
      birth_date += "0";
    }
    birth_date += (date.getMonth() + 1);
    birth_date += "-";
    if(date.getDate() < 10){
      birth_date += "0";
    }
    birth_date += date.getDate();
  }

  const date2 = new Date(anniversary);
  let anniversary_date = undefined;
  if(date2.getFullYear() > 1900){
    anniversary_date = date2.getFullYear() + "-";
    if((date.getMonth() + 1) < 10){
      anniversary_date += "0";
    }
    anniversary_date += (date2.getMonth() + 1);
    anniversary_date += "-";
    if(date.getDate() < 10){
      anniversary_date += "0";
    }
    anniversary_date += date2.getDate();
  }
  return(
    <div className="card shadow mb-4">
      <div className="card-header py-3">            
        <button onClick={(e) => handleSubmit(e)} className={'btn btn-icon-split float-right btn-'+theme()}>
          <span className="icon text-white-50">
            <i className="fas fa-save"></i>
          </span>
          <span className="text">Save</span>
        </button>
        <h6 className={'mt-2 font-weight-bold text-'+theme()}>My Profile</h6>
      </div>
      <div className="card-body">
        <div className="row">
          {loading === true ? (
            <Progress label='Saving' small={true}/>
          ):null}
          <div className="col-md-6">
            <div className="form-group">
              <label>Name</label>
              <input type="text" value={props.user.name} className="form-control" disabled={true}/>
            </div>
            <div className="form-group">
              <label>Mobile</label>
              <input type="text" value={props.user.mobile} className="form-control" disabled={true}/>
            </div>
            <div className="form-group">
              <label>Enrollment No.</label>
              <input type="text" value={props.user.enroll} className="form-control" disabled={true}/>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Email</label>
              <input type="email" value={props.user.email} className="form-control" disabled={true}/>
            </div>
            <div className="form-group">
              <label>Status</label>
              <input type="text" value={props.user.status} className="form-control" disabled={true}/>
            </div>
            <div className="form-group">
              <label>Address</label>
              <textarea value={props.user.address} maxLength="100" className="form-control" onChange={(e) => setAddress(e.target.value)}/>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <hr/>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Gender *</label>
              <select name="gender" className="form-control" value={gender} id="gender" onChange={(e) => setGender(e.target.value)}>
                <option>--Select--</option>
                <option value="1">Male</option>
                <option value="0">Female</option>
              </select>
            </div>
            <div className="form-group">
              <label>Identity Proof and Detail</label>
              <textarea value={identity} maxLength="100" className="form-control" name="identity" placeholder="Enter ID Detail" onChange={(e) => setIdentity(e.target.value)}/>
            </div>
            <div className="form-group">
              <label>Pan Card Number</label>
              <input type="text" value={pan} maxLength="15" name="pan" className="form-control" placeholder="Enter Pan Card No." onChange={(e) => setPan(e.target.value)}/>
            </div>
            <div className="form-group">
              <label>Date of Birth *</label>
              <input type="date" value={birth_date} name="dob" className="form-control" placeholder="Enter DOB" onChange={(e) => setDob(e.target.value)}/>
            </div>
            <div className="form-group">
              <label>Date of Anniversary</label>
              <input type="date" value={anniversary_date} name="anniversary" className="form-control" placeholder="Enter Anniversary" onChange={(e) => setAnniversary(e.target.value)}/>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Bank Name</label>
              <input type="text" value={bank} maxLength="20" name="bank" className="form-control" placeholder="Enter Bank Name" onChange={(e) => setBank(e.target.value)}/>
            </div>
            <div className="form-group">
              <label>Bank Branch</label>
              <input type="text" value={bankBranch} maxLength="50" name="bank_branch" className="form-control" placeholder="Enter Branch" onChange={(e) => setBankBranch(e.target.value)}/>
            </div>
            <div className="form-group">
              <label>Bank Account No.</label>
              <input type="text" value={bankAccount} maxLength="50" name="bank_account" className="form-control" placeholder="Enter Account No." onChange={(e) => setBankAccount(e.target.value)}/>
            </div>
            <div className="form-group">
              <label>Account Holder Name</label>
              <input type="text" value={accountHolderName} maxLength="50" name="account_holder_name" className="form-control" placeholder="Enter Account Holder Name" onChange={(e) => setAccountHolderName(e.target.value)}/>
            </div>
            <div className="form-group">
              <label>IFSC Code</label>
              <input type="text" value={ifscCode} maxLength="15" name="ifsc_code" className="form-control" placeholder="Enter IFSC Code" onChange={(e) => setIfscCode(e.target.value)}/>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UserProfile;